import { useState, FormEvent } from 'react';
import { useNavigate } from 'react-router-dom';
import { useIdentity } from '../hooks/useIdentity';

export function ImportIdentityScreen(): JSX.Element {
  const navigate = useNavigate();
  const { importExistingIdentity } = useIdentity();
  const [seedOrKey, setSeedOrKey] = useState('');
  const [name, setName] = useState('');
  const [isImporting, setIsImporting] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleSubmit = (e: FormEvent<HTMLFormElement>): void => {
    e.preventDefault();
    void (async (): Promise<void> => {
      setError(null);
      setIsImporting(true);
      try {
        const imported = importExistingIdentity(seedOrKey, name || undefined);
        if (imported === null) {
          setError('Import échoué. Vérifiez le format du seed ou de la clé privée.');
        } else {
          navigate('/');
        }
      } catch (err) {
        setError("Erreur lors de l'import");
        console.error('Error importing identity:', err);
      } finally {
        setIsImporting(false);
      }
    })();
  };

  return (
    <main>
      <h1>Importer une identité</h1>
      <form onSubmit={handleSubmit} aria-label="Formulaire d'import d'identité">
        <div>
          <label htmlFor="seed">
            Seed / Phrase BIP39 / Clé privée
            <textarea
              id="seed"
              value={seedOrKey}
              onChange={(e) => {
                setSeedOrKey(e.target.value);
              }}
              placeholder="Clé hex 64 car. ou phrase BIP39 (12/24 mots anglais)"
              rows={4}
              required
              aria-describedby="seed-hint"
            />
          </label>
          <p id="seed-hint" className="hint">
            Clé hex brute ou phrase BIP39 (anglais). Passphrase BIP39 non
            supportée. Dérivation m/44&apos;/0&apos;/0&apos;/0/0.
          </p>
        </div>
        <div>
          <label htmlFor="name">
            Nom local (optionnel)
            <input
              id="name"
              type="text"
              value={name}
              onChange={(e) => {
                setName(e.target.value);
              }}
              placeholder="Mon identité"
            />
          </label>
        </div>
        {error !== null && (
          <div role="alert" aria-live="assertive">
            <p>{error}</p>
          </div>
        )}
        <div>
          <button type="submit" disabled={isImporting}>
            {isImporting ? 'Import...' : 'Importer'}
          </button>
          <button type="button" onClick={() => navigate('/')}>
            Annuler
          </button>
        </div>
      </form>
    </main>
  );
}
